// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"4789d381","144":"66bb7ba1","768":"d86614cc","803":"9291da18"}[chunkId] + ".chunk.css";
};